import { Component, OnInit, Input, Output, EventEmitter,
   trigger, state, animate, transition, style } from '@angular/core';
import { HttpApiService } from "../services/http.api";
import { ConfigurateurInit, ConfigurateurFamille,ConfigurateurGroupe } from "app/model/configurateur";
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.css'],
  animations: [
    trigger('toggleState', [
      state('true' , style({  })),
      state('false', style({ maxHeight: 0, padding: 0, display: 'none' })),
      // transition
      transition('* => *', animate('300ms')),
    ])
  ]
})
export class SplashComponent implements OnInit {

  @Output() SelectGroupe = new EventEmitter<ConfigurateurGroupe>();
  selectedFamille:ConfigurateurFamille;
  configurateurInit:ConfigurateurInit;
  
  constructor(private appService: HttpApiService, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {

    this.appService.getConfigurationInit().subscribe(data => { this.configurateurInit = data; this.checkAutoLoad(); });
  }

  checkAutoLoad() {
    if (this.configurateurInit != null && this.configurateurInit.familles != null && this.configurateurInit.familles.length == 1) {
      this.selectedFamille = this.configurateurInit.familles[0];

      if (this.selectedFamille.groupes != null && this.selectedFamille.groupes.length == 1) {
        this.onClickGroupe(this.selectedFamille.groupes[0]);
      }
    }
  }

  showFamille() {
    return this.configurateurInit != null && this.configurateurInit.familles != null && this.configurateurInit.familles.length > 0;
  }

   showGroupe(famille:ConfigurateurFamille) {
    return this.selectedFamille != null  
            && this.selectedFamille.groupes != null 
            && this.selectedFamille.groupes.length > 0 
            && famille != null
            && famille.code == this.selectedFamille.code ;
  }


  onClickFamille(famille:ConfigurateurFamille) {
    //console.log('onClickFamille ');
    this.selectedFamille = famille;
    
  }

  onClickGroupe(groupe:ConfigurateurGroupe) {

    this.SelectGroupe.emit(groupe);

  }

  getBackgroundImg () {
    return (this.configurateurInit != null && this.configurateurInit.background_img != null ? 
    {'background-image':'url(\"' + this.configurateurInit.background_img + '\")', 'width': '990px', 'height': '660px'} : 
    {'background-color':'#999999;', 'width': '990px', 'height': '660px'});
  }

  getVersion() {
      return (this.configurateurInit != null && this.configurateurInit.version != null ? this.configurateurInit.version : 'not initialize yet');
  }

  getService() {
    return (this.configurateurInit != null ? 'Service chargé' : 'Service en cours de chargement...');
  }

  getTitre1() {
    return (this.configurateurInit != null && this.configurateurInit.titre1 != null ? 
      this.configurateurInit.titre1 : '');
  }

  getTitre2() {
    return (this.configurateurInit != null && this.configurateurInit.titre2 != null ? 
      this.configurateurInit.titre2 : '');
  }
}


// WEBPACK FOOTER //
// ./src/app/splash/splash.component.ts